// This function is used to assign presentational labels to the chart that
// corresponds to the data provided from the database.
// e.g. "1" can be shown as either 'Day 1', 'Monday', 'Mon' in charts.
const labeling = (value, use, mapping) => {
  // No mapping data? Simply quit early and return back the value.
  if (!mapping) return value;

  // If the value is not being supported in the mapping, quit early and return back the value.
  if (!mapping[value]) return value;

  // If the used set is not found or left undefined. Just use the first in the list.
  if (!mapping[value][use]) return Object.values(mapping[value])[0];

  return mapping[value][use];
};

export default labeling;
